import React, {Component} from "react";
import ReactDOM from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/stylish-portfolio.css";

import Sidebar from "./components/sidebar";
import Header from "./components/Header/header.js";
import Social from "./components/social";
import PortfolioSection from "./components/Portfolio/portfolio";
import AboutSection from "./components/About/about.js";
// import AboutMe from "./components/aboutme";

class App extends Component {
  render() {
    return (
      <div>
        <Sidebar />
        <Header />
        {/* <AboutMe /> */}
        <AboutSection />
        <PortfolioSection />
        <Social />
      </div>
    );
  }
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
